<template>
  <div class="receiptBaseInfo">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  import DataBaseAPI from '@/api/dataBase';

  export default {
    name: 'receiptBaseInfo',
    components: {
      baseForm,
    },
    props: ['canEdit', 'departmentList', 'receiveStatusType', 'disabledBusinessType'],
    data() {
      return {
        baseData: {
          id: null,
          docNo: null, // 收款单号
          registerNo: null, // 收款登记号
          registerCompanyCode: null, // 公司代码
          registerCompanyName: null, // 公司名称
          registerDate: null, // 收款日期
          createPersonNo: null,
          createPersonName: null,
          registerCreatePersonNo: null, // 制单人
          registerCreatePersonName: null, // 制单人名称
          receiveMethod: null, // 收款方式
          receiveResource: null, // 来源
          billId: null, // 应收票据ids
          billCode: null, // 应收票据号
          clCode: null, // 信用证号
          clId: null, // 信用证id
          clDetailId: null, // 信用证行号
          receiveBankNo: null, // 收款银行
          receiveBankName: null, // 收款银行名称
          receiveBankAccount: null, // 收款银行账号
          receiveStatus: null, // 收款状态
          preclaimDepartmentCode: null, // 预认领部门
          preclaimDepartmentName: null, // 预认领部门名称
          marginPayAccount: null, // 保证金付款银行账户
          gmtCreate: null, //录入日期
          businessType: null,
        },
        companyList: [],
        personList: [],
        billSelArr: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //基础数据表单配置
      baseDataOptions() {
        return [
          ...(this.receiveStatusType != 'Claim' && this.receiveStatusType != 'Register'
            ? [
                {
                  // 收款单号
                  type: 'input',
                  label: this.$t('receivablesManage.basicInfo.docNo'),
                  prop: 'docNo',
                  disabled: true,
                  placeholder: this.$t('receivablesManage.placeholder.auto'),
                },
              ]
            : []),
          ...(this.receiveStatusType != 'Order'
            ? [
                {
                  // 收款登记号
                  type: 'input',
                  label: this.$t('receivablesManage.basicInfo.registerNo'),
                  prop: 'registerNo',
                  disabled: true,
                  placeholder: this.$t('receivablesManage.placeholder.auto'),
                },
              ]
            : []),
          {
            // 公司
            type: 'select',
            label: this.$t('receivablesManage.basicInfo.registerCompanyCode'),
            prop: 'registerCompanyCode',
            options: this.companyList,
            required: true,
            filterable: true,
            disabled: !this.canEdit,
          },
          {
            // 收款日期
            type: 'date',
            label: this.$t('receivablesManage.basicInfo.registerDate'),
            prop: 'registerDate',
            required: true,
            disabled: !this.canEdit,
          },
          {
            // 制单人
            type: 'select',
            label: '制单人',
            prop: this.receiveStatusType == 'Order' ? 'createPersonNo' : 'registerCreatePersonNo',
            options: this.personList,
            required: true,
            filterable: true,
            disabled: !this.canEdit,
          },
          {
            // 收款方式
            type: 'dict',
            dictType: 'receiveMethod',
            label: this.$t('receivablesManage.basicInfo.receiveMethod'),
            prop: 'receiveMethod',
            required: true,
            disabled: !this.canEdit,
          },
          {
            // 来源
            type: 'dict',
            dictType: 'receiveResource',
            label: this.$t('receivablesManage.basicInfo.receiveResource'),
            prop: 'receiveResource',
            disabled: true,
            placeholder: this.$t('receivablesManage.placeholder.auto'),
          },
          {
            // 票据号
            type: 'searchTableLink',
            prop: 'billCode',
            isMultiple: false,
            label: this.$t('receivablesManage.basicInfo.billCode'),
            searchType: 'bill',
            required:
              ['SK03', 'SK04', 'SK05'].indexOf(this.baseData.receiveMethod) != -1 ? true : false,
            currentValue: this.baseData.billCode,
            disabled:
              !this.baseData.registerCompanyCode ||
              ['SK03', 'SK04', 'SK05'].indexOf(this.baseData.receiveMethod) == -1,
            linkData: {
              path: `/capital/${
                this.baseData.receiveMethod == 'SK05' ? 'pay' : 'collect'
              }BillDetails`,
              name: `${this.baseData.receiveMethod == 'SK05' ? 'pay' : 'collect'}BillDetails`,
              queryKey: 'id',
              getQueryKey: 'billId',
            },
            extraData: {
              billType: this.baseData.receiveMethod == 'SK05' ? '2' : '1',
              billCompanyCode: this.baseData.registerCompanyCode,
              ...(['SK03', 'SK04'].indexOf(this.baseData.receiveMethod) != -1
                ? {
                    billStatus: this.baseData.receiveMethod == 'SK03' ? '03' : '05',
                    isQuotedByFundCollection: 'true',
                  }
                : {}),
            },
          },
          {
            // 信用证号
            type: 'searchTableLink',
            prop: 'clCode',
            isMultiple: true,
            label: this.$t('receivablesManage.basicInfo.clCode'),
            searchType: this.baseData.receiveMethod == 'SK06' ? 'LC' : 'acceptanceLC',
            required: ['SK06', 'SK07'].indexOf(this.baseData.receiveMethod) != -1 ? true : false,
            currentValue: this.baseData.clCode,
            disabled: ['SK06', 'SK07'].indexOf(this.baseData.receiveMethod) == -1,
            linkData: {
              path: `/letterOfCredit/${
                this.baseData.receiveMethod == 'SK06' ? 'issuing' : 'acceptCredit'
              }`,
              name: this.baseData.receiveMethod == 'SK06' ? 'issuingLC' : 'acceptCreditLC',
              queryKey: this.baseData.receiveMethod == 'SK06' ? 'applicationId' : 'id',
              getQueryKey: 'clId',
              extraQuery: {
                ...(this.baseData.receiveMethod == 'SK06' ? {} : { returnStatus: 4 }),
                isEdit: 'N',
              },
            },
            extraData: {
              // 收款方式为信用证保证金退回时，信用证开证为已开证、已撤销、已承兑、已结清状态；
              ...(this.baseData.receiveMethod == 'SK06'
                ? { statusFlags: ['005', '006', '007', '008'] }
                : { statusFlag: '002' }),
              sourceType: this.baseData.receiveMethod == 'SK06' ? '1' : '2',
            },
          },
          {
            // 信用证行号
            type: 'input',
            label: this.$t('receivablesManage.basicInfo.clDetailId'),
            prop: 'clDetailId',
            required: this.baseData.receiveMethod == 'SK07' ? true : false,
            disabled: true,
            placeholder: this.$t('receivablesManage.placeholder.auto'),
          },
          {
            // 收款银行
            type: 'searchTable',
            prop: 'receiveBankName',
            searchType: 'bankAccountBranchName',
            //initShow: false,
            isMultiple: true,
            label: this.$t('receivablesManage.basicInfo.receiveBankNo'),
            required: this.baseData.receiveMethod != 'SK01',
            disabled:
              !this.baseData.registerCompanyCode ||
              this.baseData.receiveMethod == 'SK01' ||
              !this.canEdit,
            currentValue: this.baseData.receiveBankName,
            extraData: {
              bankAccountStatus: '001',
              companyCode: this.baseData.registerCompanyCode,
            },
          },
          {
            // 收款银行账号
            type: 'input',
            label: this.$t('receivablesManage.basicInfo.receiveBankAccount'),
            prop: 'receiveBankAccount',
            placeholder: this.$t('receivablesManage.placeholder.auto'),
            disabled: true,
          },
          {
            // 收款状态
            type: 'dict',
            dictType: `receive${this.receiveStatusType}Status`,
            label: this.$t('receivablesManage.basicInfo.receiveStatus'),
            prop: 'receiveStatus',
            disabled: true,
            placeholder: this.$t('receivablesManage.placeholder.auto'),
          },
          {
            // 预认领部门
            type: 'select',
            label: this.$t('receivablesManage.basicInfo.preclaimDepartmentName'),
            prop: 'preclaimDepartmentCode',
            options: this.departmentList,
            filterable: true,
            disabled: !this.canEdit,
          },
          {
            label: '业务类别',
            type: 'select',
            prop: 'businessType',
            required: true,
            options: this.dictListMap.businessCategory,
            changeMethod: 'changeMethod',
            filterable: true,
            disabled: this.disabledBusinessType,
          },

          ...(['SK05', 'SK06', 'SK08'].indexOf(this.baseData.receiveMethod) != -1
            ? [
                {
                  // 保证金付款银行账号
                  type: 'searchTable',
                  prop: 'marginPayAccount',
                  searchType: 'bankAccount',
                  isMultiple: true,
                  label: this.$t('receivablesManage.basicInfo.marginPayAccount'),
                  required: true,
                  currentValue: this.baseData.marginPayAccount,
                  extraData: {
                    bankAccountStatus: '001',
                    companyCode: this.baseData.registerCompanyCode,
                    // 应付票据保证金退回SK05——>承兑汇票保证金账户ASC16
                    // 信用证保证金退回SK06——>国内信用证保证金账户ASC17或国际信用证保证金账户ASC18
                    ...(['SK05', 'SK06'].indexOf(this.baseData.receiveMethod) != -1
                      ? {
                          secondaryClassCodes:
                            this.baseData.receiveMethod == 'SK05' ? ['ASC16'] : ['ASC17', 'ASC18'],
                        }
                      : {}),
                  },
                  disabled: !this.canEdit,
                },
              ]
            : []),
        ];
      },
    },
    mounted() {
      this.getCompany();
      this.getPerson();
      if (this.$route.name.indexOf('add') != -1) {
        this.baseData.createPersonNo = this.baseData.registerCreatePersonNo =
          this.userInfo.userCode;
        this.baseData.createPersonName = this.baseData.registerCreatePersonName =
          this.userInfo.userName;
        this.baseData.registerCompanyCode = this.userInfo.companyCode;
        this.baseData.registerCompanyName = this.userInfo.companyName;
        // 01-贸易，02-多式联运，03-园区仓储，04-园区物业，05-监管单
        if (this.userInfo.businessGroup == '物贸') {
          this.baseData.businessType = '01';
        }
        if (this.userInfo.businessGroup == '多式联运') {
          this.baseData.businessType = '02';
        }
      }
    },
    methods: {
      handleChangeBaseData(value, prop) {
        //基本数据表单变化
        if (prop == 'registerCompanyCode') {
          this.companyChange(value.registerCompanyCode);
        }
        if (prop == 'registerDate') {
          this.$emit('getRate');
        }
        if (prop == 'registerCreatePersonNo') {
          this.personChange(value.registerCreatePersonNo);
        }
        if (prop == 'billCode') {
          this.billChange(value.billCode);
        }
        if (prop == 'clCode') {
          this.LCChange(value.clCode);
        }
        if (prop == 'receiveBankName') {
          this.bankBranchChange(value.receiveBankName);
        }
        if (prop == 'receiveMethod') {
          this.baseData.billCode =
            this.baseData.clCode =
            this.baseData.billId =
            this.baseData.clId =
            this.baseData.marginPayAccount =
              null;
          if (this.baseData.receiveMethod == 'SK01') {
            this.baseData.receiveBankNo =
              this.baseData.receiveBankName =
              this.baseData.receiveBankAccount =
                '';
          }
        }
        if (prop == 'preclaimDepartmentCode') {
          this.baseData.preclaimDepartmentName = value.preclaimDepartmentCode
            ? this.departmentList.find((item) => item.value == value.preclaimDepartmentCode).label
            : null;
        }
        if (prop == 'marginPayAccount') {
          this.marginPayAccountChange(value.marginPayAccount);
        }
      },
      // async getCompany() { // 公司
      //   let res = await this.$baseRequest.getCompanyList();
      //   if (res) {
      //     this.companyList = res;
      //   }
      // },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async getPerson() {
        // 制单人
        let res = await this.$baseRequest.getPerson();
        if (res) {
          this.personList = res.map((item) => {
            return {
              value: item.id + '',
              label: item.personName,
            };
          });
          this.personList.push({
            value: 'jd',
            label: '金蝶',
          });
          console.log(this.personList, '1111-->');
        }
      },
      companyChange(val) {
        this.baseData.registerCompanyName = val
          ? this.companyList.find((item) => item.value == val).label
          : null;
        this.baseData.preclaimDepartmentCode =
          this.baseData.preclaimDepartmentName =
          this.baseData.billId =
          this.baseData.billCode =
          this.baseData.receiveBankNo =
          this.baseData.receiveBankName =
          this.baseData.receiveBankAccount =
            null;
        this.$emit('getDepartment', val);
        this.$emit('getCompanyCode', val);
      },
      personChange(val) {
        this.baseData.registerCreatePersonName = val
          ? this.personList.find((it) => it.value == val).label
          : null;
      },
      billChange(val) {
        let billIdArr = [];
        let billCodeArr = [];
        if (val && val.length > 0) {
          val.map((item) => {
            billIdArr.push(item.id);
            billCodeArr.push(item.billCode);
          });
        }
        this.baseData.billId = billIdArr.join(',');
        this.baseData.billCode = billCodeArr.join(',');
        this.billSelArr = val;
        if (['SK03', 'SK04'].indexOf(this.baseData.receiveMethod) != -1) {
          this.$emit('originReceiveMoneyAmountFoo', val, this.baseData.receiveMethod);
        }
        if (['SK03', 'SK04'].indexOf(this.baseData.receiveMethod) != -1) {
          this.$emit('getPayerName', val);
        }
      },
      LCChange(val) {
        if (val && val.length > 0) {
          this.baseData.clId = val[0].id + '';
          this.baseData.clCode = val[0].clCode;
          // 获取承兑金额，带入收款金额
          if (this.baseData.receiveMethod == 'SK06') {
            this.baseData.clDetailId = null;
          } else {
            this.baseData.clDetailId = val[0].sortNo;
          }
        } else {
          this.baseData.clId = null;
          this.baseData.clCode = null;
          this.baseData.clDetailId = null;
        }
        this.$emit('originReceiveMoneyAmountFoo', val, this.baseData.receiveMethod);
      },
      bankBranchChange(val) {
        if (val && val.length > 0) {
          this.baseData.receiveBankName = val[0].branchName;
          this.baseData.receiveBankNo = val[0].branchCode;
          this.baseData.receiveBankAccount = val[0].bankAccountNum;
        } else {
          this.baseData.receiveBankName = null;
          this.baseData.receiveBankNo = null;
          this.baseData.receiveBankAccount = null;
        }
      },
      marginPayAccountChange(val) {
        if (val && val.length > 0) {
          this.baseData.marginPayAccount = val[0].bankAccountNum;
        } else {
          this.baseData.marginPayAccount = null;
        }
      },
      exportChildData(btnType) {
        // 返回数据
        let baseData = {
          ...this.baseData,
          receiveStatus: btnType,
        };
        if (btnType == '00' || btnType == '01' || btnType == '04') {
          // 点击提交，走校验
          let sign = false;
          this.$refs.baseData.$refs.ruleForm.validate((valid) => {
            if (valid) {
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? baseData : false;
        } else {
          return baseData;
        }
      },
    },
    watch: {
      baseData: {
        handler() {
          console.log('监听', this.baseData);
          this.$emit('updateFormData', this.baseData);
        },
        deep: true,
        immediate: true,
      },
    },
  };
</script>
